import http from '@/services/http';

//-------------------- GETS ----------------------

export async function getInventories(filter) {
  try {
    let res = await http.get('/Inventory');
    if (filter) {
      return res.data.data.filter(item => item[filter]);
    } else {
      return res.data.data;
    }
  } catch (e) {
    console.log(e);
  }
}

export async function getInventoryCategories(filter) {
  try {
    let res = await http.get('/InventoryCategory');
    if (filter) {
      return res.data.data.filter(item => item[filter]);
    } else {
      return res.data.data;
    }
  } catch (e) {
    console.log(e);
  }
}

//-------------------- PUTS ----------------------

export async function updateInventory(id, data) {
  try {
    const res = await http.put(`/Inventory/${id}`, data);
    return res;
  } catch (e) {
    console.log(e);
  }
}

export async function updateInventoryCategory(id, data) {
  try {
    const res = await http.put(`/InventoryCategory/${id}`, data);
    return res;
  } catch (e) {
    console.log(e);
  }
}

//-------------------- POSTS ----------------------

export async function createNewInventory(data) {
  try {
    const res = await http.post('Inventory', data);
    return res;
  } catch (e) {
    console.log(e);
  }
}

export async function createNewInventoryCategory(data) {
  try {
    const res = await http.post('InventoryCategory', data);
    return res;
  } catch (e) {
    console.log(e);
  }
}
